const accredit = {
  path: 'accredit',
  component: resolve => require(['../../../../../../../pages/admin/merchant/signing/yftAlipay/accredit'], resolve),
  meta: {isAccredit: true}
}

export default accredit
